module.exports = __webpack_public_path__ + "assets/2f160ad72987c6ffb233a655630145f6.png";